import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from './table';
import Datamap from './datamap';
import DistributionSelector from './distributionSelector';
import * as styles from './app.css';

class App extends Component {
  constructor() {
    super();
    this.state = {};

    this.renderError = this.renderError.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
    this.renderMap = this.renderMap.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }
  componentDidMount() {
    this.appRef.querySelectorAll('.ag-cell sup a').forEach(
      (anchor) => anchor.addEventListener('click', () => {
        const noteId = anchor.getAttribute('href');
        const tableIndex = parseInt(noteId.split('-')[1], 10);

        if (!isNaN(tableIndex) && isFinite(tableIndex)) {
          // We have a valid table index - expand the notes section
          // for the corresponding table
          const component =
            document.querySelectorAll('[kff-indicator-components]')[tableIndex];
          const notesTrigger = component.querySelector('p.trigger:not(.open)');

          if (notesTrigger) {
            notesTrigger.click();
          }

          // Adjust the scrollY so the footnote the user clicked on
          // is not buried behind the nav header or wp-admin bar.
          setTimeout(() => {
            window.scrollTo(
              window.scrollX,
              window.scrollY -
                document.querySelector('header').clientHeight -
                ((document.getElementById('wpadminbar') || {}).clientHeight || 0)
            );
          });
        }
      })
    );
  }

  renderError() {
    if (this.props.error) {
      return (
        <div className={styles.loadingPlaceholder}>
          <h4 className={styles.text}>
            An error has occured when loading the data.
            <span className={styles.sub}>
              Please refresh your page, or try again later.
            </span>
          </h4>
        </div>
      );
    }
    return null;
  }

  renderLoading() {
    if (this.props.fetching) {
      return (
        <div className={styles.loadingPlaceholder}>
          <h4 className={styles.text}>
            <i
              className={
                `fa fa-circle-o-notch fa-spin fa-2x ${styles.fa}`
              }
            />
            Data are loading
          </h4>
        </div>
      );
    }
    return null;
  }

  renderMap() {
    if (!this.props.fetching &&
      !this.props.error &&
      ('map' === this.props.type || 'all' === this.props.type)
    ) {
      return (
        <div>
          <DistributionSelector />
          <Datamap />
        </div>
      );
    }
    return null;
  }

  renderTable() {
    if (!this.props.fetching && !this.props.error &&
      ('table' === this.props.type || 'all' === this.props.type)
    ) {
      return (<Table appIndex={this.props.appIndex || 0} />);
    }
    return null;
  }

  render() {
    return (
      <div
        ref={(node) => {
          this.appRef = node;
        }}
      >
        {this.renderLoading()}
        {this.renderError()}
        {this.renderMap()}
        {this.renderTable()}
      </div>
    );
  }
}

App.propTypes = {
  error: React.PropTypes.bool,
  fetching: React.PropTypes.bool,
  type: React.PropTypes.string,
  appIndex: React.PropTypes.number,
};

export default connect((state) => ({
  type: state.data.type,
  error: state.data.error,
  fetching: state.data.isFetching,
}))(App);



// WEBPACK FOOTER //
// ./app/components/app.js